import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import DiagramConfiguration from '@/projects/entities/diagram-configuration'

@Component
export default class BubbleDiagramConfiguration extends Vue {

    public configuration: DiagramConfiguration = new DiagramConfiguration()
    public dialog = false
    public editMode = false

    public edit(configuration: DiagramConfiguration) {
        this.configuration = configuration
        this.dialog = true
        this.editMode = true
    }

    public close() {
        this.dialog = false
    }

    private async save() {
        this.$emit('update', this.configuration)
    }
}
